<template>
  <div>
    <el-dialog
      title="新增注销账户"
      :visible.sync="centerDialogVisible"
      v-if="centerDialogVisible"
      width="800px"
      class="dialog"
      center
    >
      <div class="LogOutadd">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="110px"
          class="demo-ruleForm"
        >
          <el-form-item label="客户电话" prop="mobile">
            <div>
              <el-input
                v-model="ruleForm.mobile"
                placeholder="请输入客户电话"
                @blur="getmemberinfo"
                clearable
              ></el-input>
            </div>
          </el-form-item>
          <div v-if="info" style="margin-bottom: 20px;">
            用户所在仓：{{ info.logistics_name }} 下单总金额：{{
              info.order_amt
            }}
            元 售后总金额：{{ info.refund_amt }}元 最后一次下单时间：{{
              info.last_order_time
            }}
          </div>
          <el-form-item label="注销原因" prop="reason">
            <div>
              <el-input
                type="textarea"
                v-model="ruleForm.reason"
                maxlength="200"
                placeholder="请输入注销原因"
                clearable
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item
            label="注销证明：（请上传用户要求注销的证明）"
            prop="pic"
          >
            <el-upload
              v-loading="loadingImage"
              element-loading-text="正在上传..."
              action="#"
              :on-preview="handlePictureCardPreview"
              :file-list="pic"
              :class="{ hide: pic.length == 10 }"
              list-type="picture-card"
              :http-request="
                (file) => {
                  return uploadFile(file, 'pic');
                }
              "
              :before-remove="
                (file, fileList) => {
                  return deleteFile(file, fileList, 'pci');
                }
              "
              :limit="10"
            >
              <i slot="trigger" class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
          <div style="color: red;">
            注销不可恢复，请谨慎操作；
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="tianku">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { postBannerUpload } from "@/api/generalControl/banner";
import { compress } from "image-conversion";
export default {
  name: "LogOutadd",
  props: {},
  data() {
    return {
      //列表页面不同功能参数
      ruleForm: {
        member_id: "",
        mobile: "",
        reason: "",
        pic: "",
      },
      info: "",
      rules: {
        pic: [{ required: true, message: "请上传图片", trigger: "blur" }],
        mobile: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        reason: [
          { required: true, message: "请输入注销原因", trigger: "blur" },
        ],
      },
      loadingImage: false,
      pic: [],
      centerDialogVisible: false,
    };
  },
  methods: {
    tianku() {
      console.log(this.ruleForm);
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.tool.debounce(() => {
            this.$api.member.deletesave(this.ruleForm).then((res) => {
              this.$message({
                type: "success",
                message: "添加成功",
              });
              this.centerDialogVisible = false;
              // this.Refresh();
              this.$emit('Refresh',true)
            });
          });
        }
      });
    },
    getmemberinfo() {
      this.$api.member
        .searchinfo({
          mobile: this.ruleForm.mobile,
        })
        .then((res) => {
          console.log(res);
          this.info = res.data;
          this.ruleForm.member_id = res.data.id;
        }).catch(err=>{
              this.info = '';
          this.ruleForm.member_id = '';
        });
    },
    hqinfo(e) {
      Object.assign(this.$data.ruleForm, this.$options.data().ruleForm);
      this.pic = [];
      this.info='';
      this.centerDialogVisible = true;
    },
    deleteFile(file, fileList, name) {
      console.log(file, "删除");
      console.log(fileList, "删除");
      this[name] = fileList;
      this.ruleForm[name] = this[name].map((el) => el.url).join(",");
    },
    uploadFile(options, name) {
      // 拿到 file
      this.loadingImage = true;
      let file = options.file;
      let date = new Date().getTime();
      console.log(file, "文件");
      console.log(file.size / 1024 / 1024);
      compress(file, 0.9).then((res) => {
        console.log(res);
        console.log(res.size / 1024 / 1024);
        if (res.size / 1024 / 1024 > 50) {
          this.tool.message("图片超过50M,请重新上传", "error");
          this.loadingImage = false;
        } else {
          var event = event || window.event;
          var reader = new FileReader();
          reader.readAsDataURL(res);
          reader.onload = (e) => {
            console.log(e);
            this.uploadImage(e.target.result, name);
          };
        }
      });
    },
    async uploadImage(img, name) {
      try {
        let { data } = await postBannerUpload({ file_data: img });
        this[name].push({ url: data, uid:data });
        this.ruleForm[name] = this[name].map((el) => el.url).join(",");
      } catch (error) {
        console.error("ajax postBannerUpload err", err);
      } finally {
        this.loadingImage = false;
      }
    },
    handlePictureCardPreview(file) {
      console.log("object", file);
      //   this.pic = file.url;
      //  pic
    },
  },
};
</script>

<style lang="scss" scoped>
.LogOutadd {
  padding: 30px;
  box-sizing: border-box;
}
</style>
